export const baseUrl = 'https://api.spacexdata.com/v3/';

export const headers = {
  'Content-type': 'application/json',

};
